import { environment } from "ng/src/environments/environment";

export function replaceConsoleLogging(console: Console, enabled: () => boolean = () => true) {
	const oLog = console.log.bind(console);
	const oDebug = console.debug.bind(console);
	const oInfo = console.info.bind(console);
	
	const printBuilder = (type: 'log' | 'debug' | 'info') => {
		const print = (type: 'log' | 'debug' | 'info', ...params: any[]) => {
			if (!enabled()) {
				return;
			}
			switch (type) {
				case "log":
					oLog(...params);
					return;
				case "info":
					oInfo(...params);
					return;
				case "debug":
					oDebug(...params);
					return;
			}
		}
		
		return (...params: any[]) => {
			print(type, ...params);
		}
	}
	
	console.log = printBuilder('log');
	console.debug = printBuilder('debug');
	console.info = printBuilder('info');
}

export function isLoggingEnabled(localStorage: Storage): () => boolean {
	return function (): boolean {
		const item = localStorage.getItem('logging-enabled');
		const defaultVal = (environment.production ? 'false' : 'true');
		return (item?.toLocaleLowerCase() ?? defaultVal) === 'true';
	}
}